import React from 'react'
import LoaderFetch from '../LoaderFatch/Loader'

function Loader() {
    return (
        <LoaderFetch />
    )
}

export default Loader